import { render } from "./AdminHeroImage.vue?vue&type=template&id=05606c21&scoped=true"
import script from "./AdminHeroImage.vue?vue&type=script&lang=js"
export * from "./AdminHeroImage.vue?vue&type=script&lang=js"

import "./AdminHeroImage.vue?vue&type=style&index=0&id=05606c21&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05606c21"]])

export default __exports__